export default "__VITE_ASSET__R6OMNkXY__ 584w";